import styled from 'styled-components';

export const StyledInterviewCount = styled.span`
  color: ${({ theme }) => theme.colors.dustyGray};
  font-weight: bold;
`;
